import { memo } from 'util/memoizationUtils';
import BackendService from './BackendService';

export default class PenService {
  static registerDealer(dealerId) {
    return BackendService.post(`/pen/api/dealers/${dealerId}`);
  }

  static addProviderToDealer(payload) {
    const { dealerId, providerId, providerDealerCode, name } = payload;
    const provider = {
      id: providerId,
      providerDealerCode,
      name,
    };
    return BackendService.post(`/pen/api/dealers/${dealerId}/providers`, {
      body: { provider },
    });
  }

  static getProviders() {
    return BackendService.get(`/pen/api/providers`);
  }

  static getProviderProducts(payload) {
    const { providerId } = payload;
    return BackendService.get(`/pen/api/providers/${providerId}/products`);
  }

  static registerProduct({
    dealerId,
    productId,
    providerDealerCode,
    productDealerCode,
  }) {
    return BackendService.post(
      `/pen/api/products/${dealerId}/${productId}/register`,
      {
        body: { providerDealerCode, productDealerCode },
      },
    );
  }

  static getRateBookCodes({ dealerId, productId }) {
    return BackendService.get(
      `/pen/api/rateBookCodes/${dealerId}/${productId}`,
    );
  }

  static getCoveragesAndDeductibles(payload) {
    const {
      dealerId,
      productId,
      conditionFinanceTypes,
      providerId,
      rateBookCode,
      conditionInputValuesForCoverage,
      purchaseTerm,
    } = payload;
    return BackendService.post(
      `/pen/api/products/${dealerId}/${productId}/${providerId}/coverageNames`,
      {
        body: {
          conditionFinanceTypes,
          rateBookCode,
          conditionInputValuesForCoverage,
          purchaseTerm,
        },
      },
    );
  }

  static editProduct(payload) {
    const { formData, dealerId, productId } = payload;
    return BackendService.put(
      `/pen/api/products/${dealerId}/${productId}`,
      {
        formData,
      },
      true,
    );
  }

  static createProduct(payload) {
    const { formData, dealerId } = payload;
    return BackendService.post(
      `/pen/api/products/${dealerId}`,
      {
        formData,
      },
      true,
    );
  }

  static createBundle(payload) {
    const { formData, dealerId, condition, financeType } = payload;
    const params = {
      condition,
      financeType,
    };
    return BackendService.post(
      `/pen/api/bundles/${dealerId}`,
      {
        params,
        formData,
      },
      true,
    );
  }

  static editBundle(payload) {
    const { formData, dealerId, bundleId, condition, financeType } = payload;
    const params = {
      condition,
      financeType,
    };
    return BackendService.put(
      `/pen/api/bundles/${dealerId}/${bundleId}`,
      {
        params,
        formData,
      },
      true,
    );
  }

  static registerProviderDealerCode(payload) {
    const { providerId, dealerId, providerDealerCode } = payload;
    return BackendService.post(
      `/pen/api/providers/${dealerId}/${providerId}/providerDealerCode`,
      {
        body: { providerDealerCode, dealerId },
      },
    );
  }

  static registerProductAndGetCoverages(payload) {
    const {
      productId,
      dealerId,
      providerDealerCode,
      productDealerCode,
    } = payload;
    return BackendService.post(
      `/pen/api/products/${dealerId}/${productId}/providerAndProductCodes`,
      {
        body: { providerDealerCode, productDealerCode },
      },
    );
  }

  static registerProductDealerCode(payload) {
    const { productId, dealerId, productDealerCode } = payload;
    return BackendService.put(
      `/pen/api/products/${dealerId}/${productId}/productDealerCode`,
      {
        body: { productDealerCode },
      },
    );
  }

  static getRates(dealId, financeType, activeFinanceTerm, selectedMileage) {
    const paramObj = { financeType, includeAllCoverageNames: true };
    if (activeFinanceTerm) {
      paramObj.activeFinanceTerm = activeFinanceTerm;
    }
    if (selectedMileage) {
      paramObj.selectedMileage = selectedMileage;
    }
    return BackendService.get(`/pen/api/rates/${dealId}`, {
      params: paramObj,
    });
  }

  static memoizedGetRates = memo(PenService.getRates);
}
